import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { alertActions } from '@actions';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(alertActions.error(t('ErrorsPages.notFoundPage')));
    }, [dispatch]);

    return <Navigate to={RoutePath.Home} replace />;
};

export default NotFoundPage;
